import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import {
  Container,
  Row,
  Badge,
  Input,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Tooltip,
} from "reactstrap";

import { Link } from "react-router-dom";

import Shimmer from "react-shimmer-effect";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/pensiunskService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

class TablePrimaryComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "pensiunDataTableActive";
  defaultOrder = "retired_employee_nip";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil diproses";
  modal_confirm_error_message = "data gagal diproses";

  constructor(props) {
    super(props);
    this.state = {
      detail: {
        tanggal: "",
        uuid: "",
        keterangan: "",
        status_submission: "",
      },
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      submitUuid: null,
      approveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      dataSelected: [],
      checkAll: false,
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let uuid = urlParams.get("uuid");

    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: -2,
      uuid: uuid,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  handleChecked = (e, uuid) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        dataSelected: [...this.state.dataSelected, uuid],
      });
    } else {
      var filteredAry = this.state.dataSelected.filter((e) => e !== uuid);
      this.setState({
        dataSelected: filteredAry,
      });
    }
    console.log(uuid, checked);
  };

  handleCheckAll = (e) => {
    let checked = e.target.checked;
    let uuidSelected = [];
    for (let i = 0; i < this.state.rows.length; i++) {
      let thisId = this.state.rows[i].retired_id;
      let thisUuid = this.state.rows[i].retired_uuid;
      this.setState({
        [`check${thisId}`]: !this.state.checkAll,
      });
      if (checked == true) {
        uuidSelected[i] = thisUuid;
      }
    }

    this.setState({
      checkAll: !this.state.checkAll,
      dataSelected: uuidSelected,
    });
  };

  handleButtonProcess = () => {
    console.log(this.state.dataSelected);
    this.modal_confirm_message =
      "Apakah anda yakin akan menambahkan pegawai terpilih?";
    this.modal_confirm_status = 1;
    this.setState({
      confirm: true,
    });
  };

  handleButtonGenerate = () => {
    this.modal_confirm_message =
      "Apakah anda yakin generate ulang Rekomendasi?";
    this.modal_confirm_status = 2;
    this.setState({
      confirm: true,
    });
  };

  resetTable = () => {
    this.setState({
      dataSelected: [],
    });
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          let formData = {
            uuids: this.state.dataSelected,
          };
          this.dataTableBloc.fetchProcess(formData);
          // forState = {
          //   loading: false,
          // };
        } else if (data_status === 2) {
          let formData = {
            uuid: this.props.uuid,
            submission_uuid: this.state.detail.uuid,
          };
          this.dataTableBloc.fetchGenerate(formData);
          // forState = {
          //   loading: false,
          // };
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.detailSubmissionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: {
                uuid: response.result.emp_retired_submission_uuid,
                tanggal:
                  reformatDate(
                    response.result.emp_retired_submission_date_start
                  ) +
                  " - " +
                  reformatDate(response.result.emp_retired_submission_date_end),
                keterangan: response.result.emp_retired_submission_description,
                status_submission:
                  response.result.emp_retired_submission_status,
              },
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.processChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState(
              {
                loading: false,
                success: true,
              },
              function () {
                this.setTokenAPI();
                this.resetTable();
                this.props.handleProcessSuccess();
              }
            );
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.generateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState(
              {
                loading: false,
                success: true,
              },
              function () {
                this.resetTable();
                this.setTokenAPI();
                this.props.handleProcessSuccess();
                // this.props.handleProcessSuccess();
              }
            );
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(window.location.search).get("uuid");
    this.dataTableBloc.fetchDetailSubmission({ uuid: queryParams });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
    this.dataTableBloc.detailSubmissionChannel.unsubscribe();
    this.dataTableBloc.inactiveChannel.unsubscribe();
    this.dataTableBloc.processChannel.unsubscribe();
    this.dataTableBloc.generateChannel.unsubscribe();
  }

  columns = [
    {
      key: "retired_id",
      text: "Pilih",
      className: "retired_id",
      sortable: false,
      header: () => {
        return (
          <div className="form-check text-center font-size-16">
            <Input
              className="form-check-input"
              type="checkbox"
              name="checkAll"
              value=""
              checked={this.state.checkAll}
              onChange={(event) => {
                this.handleCheckAll(event);
              }}
            />
          </div>
        );
      },
      cell: (record) => {
        const thisId = record.retired_id;
        return (
          <div className="form-check text-center font-size-16">
            <Input
              type="checkbox"
              className="form-check-input"
              id={"checkbox" + thisId}
              onChange={(event) => {
                this.handleChecked(event, record.retired_uuid);
                this.setState({
                  [`check${thisId}`]: !this.state[`check${thisId}`],
                });
              }}
              checked={this.state[`check${thisId}`]}
            />
          </div>
        );
      },
    },
    {
      key: "retired_employee_nip",
      text: "Pegawai",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<b>" +
                record.retired_employee_nip +
                "</b><br>" +
                record.retired_employee_name +
                "<br>",
            }}
          />
        );
      },
    },
    {
      key: "retired_employee_position_name",
      text: "Posisi",
      className: "retired_employee_position_name", //
      sortable: true,
    },
    {
      key: "retired_employee_work_unit_name",
      text: "Unit Kerja",
      className: "retired_employee_work_unit_name", //
      sortable: true,
    },
    {
      key: "retired_employee_position_name",
      text: "Jabatan",
      className: "retired_employee_position_name",
      sortable: true,
    },
    {
      key: "retired_employee_position_tmt",
      text: "TMT Jabatan",
      className: "retired_employee_position_tmt",
      sortable: true,
    },
    {
      key: "retired_employee_level_name",
      text: "Golongan",
      className: "retired_employee_level_name",
      sortable: true,
    },
    {
      key: "retired_employee_retired_date",
      text: "Tgl Pemberhentian",
      className: "retired_employee_retired_date",
      sortable: true,
    },
    {
      key: "retired_employee_retired_date_tmt",
      text: "TMT Pemberhentian",
      className: "retired_employee_retired_date_tmt",
      sortable: true,
    },
    {
      key: "retired_type_name",
      text: "Jenis",
      className: "retired_type_name",
      sortable: true,
    },
    {
      key: "retired_type_stop_name",
      text: "Jenis Pemberhentian",
      className: "retired_type_stop_name",
      sortable: true,
    },
    {
      key: "employee_age",
      text: "Usia Sekarang",
      className: "employee_age",
      sortable: true,
    },
    {
      key: "employee_age_retired",
      text: "Usia Pemberhentian",
      className: "employee_age_retired",
      sortable: true,
    },
    {
      key: "retired_employee_status",
      text: "Status",
      className: "retired_employee_status",
      sortable: true,
      cell: (record) => {
        var status = record.retired_employee_status;
        return (
          <span>
            {parseInt(status) === -2 ? (
              <label className="badge rounded-pill bg-soft-primary font-size-12">
                Rekomendasi
              </label>
            ) : (
              <label></label>
            )}
          </span>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <Row>
          <label className="">
            Periode&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.detail.tanggal ? (
              <>
                {this.state.detail.tanggal !== ""
                  ? this.state.detail.tanggal
                  : "-"}
              </>
            ) : (
              <Shimmer>
                <div style={{ width: 68, height: 15 }}></div>
              </Shimmer>
            )}
          </label>
          <label className="">
            Keterangan&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.detail.keterangan ? (
              <>
                {this.state.detail.keterangan !== ""
                  ? this.state.detail.keterangan
                  : "-"}
              </>
            ) : (
              <Shimmer>
                <div style={{ width: 68, height: 15 }}></div>
              </Shimmer>
            )}
          </label>
        </Row>
        <b>
          Data Terpilih :{" "}
          <Badge className="rounded-pill bg-success font-size-12">
            {" "}
            {this.state.dataSelected.length}{" "}
          </Badge>{" "}
          dari total{" "}
          <Badge className="rounded-pill bg-warning font-size-12">
            {" "}
            {this.state.totalRow}{" "}
          </Badge>
        </b>
        &nbsp;&nbsp;&nbsp;&nbsp;
        {accessRole("create") && this.state.detail.status_submission === 0 ? (
          <Button
            color="primary"
            onClick={() => {
              this.handleButtonProcess();
            }}
            disabled={this.state.dataSelected.length > 0 ? false : true}
          >
            Masukan Pegawai Terpilih
          </Button>
        ) : null}
        &nbsp;&nbsp;&nbsp;&nbsp;
        {/* {accessRole("create") ? (
          <Button
            color="success"
            onClick={() => {
              this.handleButtonGenerate();
            }}
          >
            Generate Ulang Rekomendasi
          </Button>
        ) : null} */}
        <hr />
        <br />
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/pensiun.html?detail&uuid=" + this.state.detailUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/pensiun.html?update&uuid=" + this.state.updateUuid
            }
          />
        ) : null}
        {this.state.submitUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/pensiun.html?submit&uuid=" + this.state.submitUuid
            }
          />
        ) : null}
        {this.state.approveUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/pensiun.html?approve&uuid=" + this.state.approveUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TablePrimaryComponent;
